<template>
  <RouterLink v-bind="{ ...props, custom: true }" v-slot="{ isActive, navigate, href }">
    <Component :is="tag" class="size-full cursor-pointer" @click="navigate()">
      <slot :href="href" :navigate="navigate" :is-active="isActive" />
    </Component>
  </RouterLink>
</template>

<script lang="ts" setup>
import type { RouterLinkProps } from 'vue-router'

const props = withDefaults(defineProps<RouterLinkProps & { tag?: string }>(), {
  tag: 'div'
})
</script>
